import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Link Variant"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-link-variant',
    templateUrl: './icon-link-variant.component.html',
    styleUrls: ['./icon-link-variant.component.scss'],
    standalone: false
})
export class IconLinkVariantComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
